module.exports = __webpack_public_path__ + "static/media/m.7d5afb1e.png";